import {
  CONTRATACIONES_AMBITO,
  AREAS_CONSULTA,
  EMAILS_ASOCIADOS,
  CONTRATACIONES_MOTIVOS,
  AUTORIZACIONES_MOTIVOS,
  LIQUIDACIONES_MOTIVOS,
  DETALLE_TRAMITES_CAP,
  LOAD_INBOX,
  LOAD_TABLE,
  LOAD_DETALLE_TRAMITE,
  SET_ARCHIVOS_ETAPAS,
  SET_TRAMITE_RESPONDER,
  REMOVE_TRAMITE_FROM_PENDIENTES,
  SET_ACTIVE_TAB,
  SELECT_TRAMITE_AUTORIZACION,
  SELECT_AFILIADO_AUTORIZACION,
  CAP_LIQUIDACIONES_SET_INVOICE,
  SET_TRAMITE_SELECCIONADO_CAP,
  RESET_CAP_WEB_STATE,
} from '../constants/index';

const initialState = {
  emails: null,
  ambito: null,
  areasDeConsulta: null,
  detallesTramites: [],
  inbox: [],
  resultadoBusqueda: [],
  unread: 0,
  detalleTramite: null,
  tramiteSaved: null,
  active: 'altaDeTramites',
  tramiteSeleccionado: '',
  tipoTramite: '',
  autorizaciones: {},
  liquidaciones: {},
};

export default function capweb(state = initialState, action) {
  // if(!state){
  //   state = initialState
  // }

  const newState = { ...state };

  switch (action.type) {
    case CONTRATACIONES_AMBITO:
      newState.ambito = action.ambito;
      return newState;
    case AREAS_CONSULTA:
      newState.areasDeConsulta = action.areasDeConsulta;
      return newState;
    case EMAILS_ASOCIADOS:
      newState.emails = action.emails;
      return newState;
    case CONTRATACIONES_MOTIVOS:
      newState.contratacionesMotivos = action.contratacionesMotivos;
      return newState;
    case DETALLE_TRAMITES_CAP:
      newState.detallesTramites[action.detalleTramite.nroTramite] = action.detalleTramite.detalle;
      return newState;
    case LOAD_INBOX:
      return {
        ...state,
        inbox: action.pendientes,
        unread: action.pendientes.length,
        detalleTramite: null,
      };
    case LOAD_TABLE:
      return { ...state, resultadoBusqueda: action.tramites };
    case LOAD_DETALLE_TRAMITE:
      newState.detalleTramite = action.detalle;
      if (newState.detalleTramite) {
        newState.detalleTramite.tasks = action.tasks;
        // aca filtro las etapas que son solo internas. Lo hago asi por si se guardar '' en obsColaborador.
        newState.detalleTramite.etapas = action.detalle.etapas.filter(
          (etapa) =>
            (etapa.obsColaborador && etapa.obsColaborador.trim().length > 0) || etapa.obsWeb,
        );
      }
      return newState;
    case SET_ARCHIVOS_ETAPAS:
      return {
        ...state,
        detalleTramite: {
          ...state.detalleTramite,
          adjuntos: action.payload.adjuntos,
        },
      };
    case SET_TRAMITE_RESPONDER:
      return { ...state, detalleTramite: action.tramite };
    case AUTORIZACIONES_MOTIVOS:
      newState.autorizacionesMotivos = action.autorizacionesMotivos;
      return newState;
    case LIQUIDACIONES_MOTIVOS:
      newState.liquidacionesMotivos = action.liquidacionesMotivos;
      return newState;
    case REMOVE_TRAMITE_FROM_PENDIENTES: {
      const pendientes = newState.inbox.filter((item) => item.tramiteJbpm !== action.tramiteId);
      const tramites = newState.resultadoBusqueda.map((tramite) => {
        if (tramite.tramiteJbpm === action.tramiteId) {
          tramite.estado = 'En Proceso';
        }
        return tramite;
      });

      return {
        ...state,
        inbox: pendientes,
        unread: pendientes.length,
        resultadoBusqueda: tramites,
      };
    }
    case SET_ACTIVE_TAB: {
      return {
        ...state,
        active: action.payload.active,
        autorizaciones: {
          tramiteAutorizacion: action.payload.selectedTramite,
          afiliado: null,
        },
      };
    }
    case SELECT_TRAMITE_AUTORIZACION: {
      if (action.active) {
        return {
          ...state,
          autorizaciones: {
            tramiteAutorizacion: action.tramite,
            afiliado: null,
          },
          active: action.active,
        };
      }
      return {
        ...state,
        autorizaciones: {
          tramiteAutorizacion: action.tramite,
          afiliado: null,
        },
      };
    }
    case CAP_LIQUIDACIONES_SET_INVOICE: {
      return {
        ...state,
        liquidaciones: {
          tramite: action.payload,
        },
        active: 'altaDeTramites',
      };
    }
    case SELECT_AFILIADO_AUTORIZACION: {
      if (action.active) {
        return {
          ...state,
          autorizaciones: {
            tramiteAutorizacion: null,
            afiliado: action.afiliado,
          },
          active: action.active,
        };
      }
      return {
        ...state,
        autorizaciones: {
          tramiteAutorizacion: null,
          afiliado: action.afiliado,
        },
      };
    }
    case SET_TRAMITE_SELECCIONADO_CAP: {
      return {
        ...state,
        tramiteSeleccionado: action.payload,
      };
    }
    case RESET_CAP_WEB_STATE: {
      return { ...initialState };
    }
    default:
      return newState;
  }
}
